export default __webpack_public_path__ + "static/media/mareja_1.70fc3e48.jpeg";